(function () {
  function init(bar) {
    var submitId = bar.getAttribute('data-submit-id');
    var trigger = document.querySelector('.product-form__buttons') || document.getElementById(submitId);
    var button = bar.querySelector('[data-sticky-atc-button]');

    if (button) {
      button.addEventListener('click', function () {
        var realSubmit = document.getElementById(submitId);
        if (realSubmit) {
          realSubmit.click();
        } else {
          document.querySelector('.product-form__buttons')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }

    if (!trigger || !('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { rootMargin: '0px' }
    );
    observer.observe(trigger);
  }

  document.querySelectorAll('[data-sticky-atc]').forEach(init);
})();
